import { IEntityInfo } from "namirasoft-account-react";
import { AssetRow, SummaryRow } from "namirasoft-balance";
import { NSLoading } from "namirasoft-site-react";
import { useEffect, useState } from "react";
import { SummaryStatementLine } from "./SummaryStatementLine";
import Styles from "./SummaryStatement.module.css";

interface SummaryStatementProps
{
    entity: IEntityInfo<SummaryRow>;
    asset: AssetRow;
}

export function SummaryStatement(props: SummaryStatementProps)
{
    const assetName = props.asset.name;
    const [rows, setRows] = useState<SummaryRow[] | null>(null);

    useEffect(() =>
    {
        let cancelled = false;
        props.entity.server.list?.(null, 1, 200, [], null).then(r =>
        {
            if (!cancelled)
                setRows(r.rows);
        })
        return () => { cancelled = true; };
        // eslint-disable-next-line
    }, []);

    if (rows === null)
        return <NSLoading title="Loading statements…..." />

    if (rows.length === 0)
        return null;

    const sorted = [...rows].sort((a, b) =>
        (b.year - a.year) || (b.month - a.month)
    );

    return (
        <div className={Styles.statement_container}>
            {sorted.map(row => (
                <SummaryStatementLine key={row.id} row={row} assetName={assetName} />
            ))}
        </div>
    );
}